import { SxProps } from '@mui/material';

export const lowerFooterTermsSx: SxProps = {
	maxWidth: '100% !important',
	textAlign: 'center',
	'&__terms': {
		'.MuiTypography-root': {
			lineHeight: 1.1,
		},

		'@media screen and (max-width: 1439px)': {
			padding: 0,
			textAlign: 'center',
		},

		'@media screen and (max-width: 960px)': {
			padding: 0,
			textAlign: 'center',

			'.MuiTypography-root': {
				display: 'flex',
				width: '90%',
				margin: '0 auto',
				textAlign: 'center',
			},
		},
	},
};
